import { archives } from "@/mocks/scandal";

export default function Archive() {
  return (
    <section id="archive" className="relative overflow-hidden border-b border-background-200/70 bg-primary-50/30">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-block h-4 w-1.5 rounded-sm bg-primary-500" />
              <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Resource Archive</span>
            </div>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">归档资源 · 整套搬走慢慢看</h2>
            <p className="mt-2 text-sm text-foreground-500">
              时间线、前因后果通稿、图片与录屏素材，都整理成可直接用的档案，入口与下载更醒目。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800 whitespace-nowrap">
            <i className="ri-download-cloud-2-line" /> 支持整包下载
          </span>
        </div>

        {/* 总包 CTA */}
        <div className="mt-8 flex flex-col items-start justify-between gap-6 rounded-xl border border-primary-200 bg-background-50 p-6 md:flex-row md:items-center md:p-7">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-archive-drawer-line text-2xl" />
            </span>
            <div>
              <h3 className="text-lg font-black text-foreground-950">抖音黑料前因后果 · 总归档包</h3>
              <p className="mt-1 text-sm text-foreground-600">
                一章到十二章的完整时间线 HTML + Markdown 通稿 + 关键素材清单，一次下载全部带走，离线也能慢慢捋。
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-file-3-line" /> 含 12 章</span>
                <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-image-line" /> 素材目录</span>
                <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-history-line" /> 更新到本日</span>
                <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-hard-drive-2-line" /> 约 690 MB</span>
              </div>
            </div>
          </div>
          <div className="flex w-full shrink-0 flex-col items-stretch gap-2 md:w-auto md:flex-row md:items-center">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700"
            >
              <i className="ri-download-2-line text-base" /> 下载完整归档包
            </a>
            <a
              href="#discuss"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 whitespace-nowrap hover:border-primary-300 hover:text-primary-700"
            >
              先看讨论再下
            </a>
          </div>
        </div>

        {/* 单项资源 */}
        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {archives.map((a) => (
            <div
              key={a.title}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${a.icon} text-xl`} />
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-900">{a.title}</h3>
                  <p className="text-[11px] text-foreground-400">{a.type} · {a.meta}</p>
                </div>
                <span className="shrink-0 text-[11px] font-medium text-foreground-400">{a.size}</span>
              </div>
              <a
                href="#download"
                className="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs font-semibold text-foreground-800 whitespace-nowrap transition-colors group-hover:border-primary-400 group-hover:bg-primary-600 group-hover:text-background-50"
              >
                <i className="ri-download-line" /> 下载
              </a>
            </div>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-1.5 text-xs leading-relaxed text-foreground-400">
          <i className="ri-information-line mt-0.5" />
          页面下载为示意入口，正式文件需在维护方授权渠道获取；网页只负责整理结构与出处。
        </p>
      </div>
    </section>
  );
}